export const yellow = {
  1: { value: { base: '{colors.yellow.light.1}', _dark: '{colors.yellow.dark.1}' } },
  2: { value: { base: '{colors.yellow.light.2}', _dark: '{colors.yellow.dark.2}' } },
  3: { value: { base: '{colors.yellow.light.3}', _dark: '{colors.yellow.dark.3}' } },
  4: { value: { base: '{colors.yellow.light.4}', _dark: '{colors.yellow.dark.4}' } },
  5: { value: { base: '{colors.yellow.light.5}', _dark: '{colors.yellow.dark.5}' } },
  6: { value: { base: '{colors.yellow.light.6}', _dark: '{colors.yellow.dark.6}' } },
  7: { value: { base: '{colors.yellow.light.7}', _dark: '{colors.yellow.dark.7}' } },
  8: { value: { base: '{colors.yellow.light.8}', _dark: '{colors.yellow.dark.8}' } },
  9: { value: { base: '{colors.yellow.light.9}', _dark: '{colors.yellow.dark.9}' } },
  10: { value: { base: '{colors.yellow.light.10}', _dark: '{colors.yellow.dark.10}' } },
  11: { value: { base: '{colors.yellow.light.11}', _dark: '{colors.yellow.dark.11}' } },
  12: { value: { base: '{colors.yellow.light.12}', _dark: '{colors.yellow.dark.12}' } },
  a1: { value: { base: '{colors.yellow.light.a1}', _dark: '{colors.yellow.dark.a1}' } },
  a2: { value: { base: '{colors.yellow.light.a2}', _dark: '{colors.yellow.dark.a2}' } },
  a3: { value: { base: '{colors.yellow.light.a3}', _dark: '{colors.yellow.dark.a3}' } },
  a4: { value: { base: '{colors.yellow.light.a4}', _dark: '{colors.yellow.dark.a4}' } },
  a5: { value: { base: '{colors.yellow.light.a5}', _dark: '{colors.yellow.dark.a5}' } },
  a6: { value: { base: '{colors.yellow.light.a6}', _dark: '{colors.yellow.dark.a6}' } },
  a7: { value: { base: '{colors.yellow.light.a7}', _dark: '{colors.yellow.dark.a7}' } },
  a8: { value: { base: '{colors.yellow.light.a8}', _dark: '{colors.yellow.dark.a8}' } },
  a9: { value: { base: '{colors.yellow.light.a9}', _dark: '{colors.yellow.dark.a9}' } },
  a10: { value: { base: '{colors.yellow.light.a10}', _dark: '{colors.yellow.dark.a10}' } },
  a11: { value: { base: '{colors.yellow.light.a11}', _dark: '{colors.yellow.dark.a11}' } },
  a12: { value: { base: '{colors.yellow.light.a12}', _dark: '{colors.yellow.dark.a12}' } },
}
